export const SEND_FEEDBACK_WITH_PHONE_RESULT = 'SEND_FEEDBACK_WITH_PHONE_RESULT';
export const SET_FEEDBACK_DATA = 'SET_FEEDBACK_DATA';
export const CLEAR_DATA_TO_FEEDBACK_REQUEST = 'CLEAR_DATA_TO_FEEDBACK_REQUEST';
export const SET_FEEDBACK_RESULT = 'SET_FEEDBACK_RESULT';
